import { Flex, Text } from '@chakra-ui/react';


const ResourceCount = ({
  count,
  resource,
  isSelected = false,
  onClick,
}: {
  count: number;
  resource: string;
  isSelected?: boolean;
  onClick?: () => void;
  }) => {
  const textColor = isSelected ? 'blue.600' : 'gray.700';
  const fontWeight = isSelected ? 800 : 600;
  return (
    <Flex gap="0.25rem" cursor="pointer" onClick={onClick} align="baseline">
      <Text
        fontSize="sm"
        lineHeight="1.25rem"
        color={textColor}
        fontWeight={fontWeight}
      >
        {count}
      </Text>
      <Text
        fontSize="sm"
        fontWeight={500}
        lineHeight="1.25rem"
        color={textColor}
      >
        {resource}
      </Text>
    </Flex>
  );
};

export default ResourceCount